module.exports = __webpack_public_path__ + "img/field.f1391848.jpg";